/** Product / product-item queries for order line-item picker (proxy GraphQL). */

export const listProductsPickerQuery = `
  query ListProductsPicker($input: ListProductsInput!) {
    listProducts(input: $input) {
      code
      totalElements
      totalPages
      currentPage
      pageSize
      products {
        id
        name
        sellingMode
        baseUnit
      }
    }
  }
`;

export const listProductItemsByProductQuery = `
  query ListProductItemsByProductForOrder($input: ListProductItemsInput!) {
    listProductItemsByProduct(input: $input) {
      code
      items {
        id
        productId
        variationName
        remainingQuantity
        reservedQuantity
        state
      }
    }
  }
`;

/** Single product item (for edit-line: stock + productId → product sellingMode). */
export const getProductItemDetailForOrderQuery = `
  query GetProductItemDetailForOrder($input: GetProductItemDetailInput!) {
    getProductItemDetail(input: $input) {
      code
      item {
        id
        productId
        variationName
        remainingQuantity
        reservedQuantity
        state
      }
    }
  }
`;

export const getProductDetailForOrderQuery = `
  query GetProductDetailForOrder($input: GetProductDetailInput!) {
    getProductDetail(input: $input) {
      code
      product {
        id
        name
        sellingMode
        baseUnit
      }
    }
  }
`;
